import * as eventTracking from './principles/event-tracking';
import * as formNavigation from './principles/leadform-navigation';
import * as formThankYou from './principles/leadform-thank-you';
import * as formValidation from './principles/leadform-validation';
import * as formVariables from './principles/leadform-variables';
import * as callbackScheduling from './principles/leadform-callback-scheduling';

document.addEventListener('DOMContentLoaded', () => {
  formValidation.setUpFormValidation();
  formValidation.validateMultiSelect();
  formNavigation.setUpFormNavigation();
  formNavigation.setupMultiSelectPanelRedirect();
  formVariables.setUpFormVariables();
  formThankYou.setUpFormThankYou();
  eventTracking.trackEvents();
  callbackScheduling.setupCallbackScheduling();
});



// WEBPACK FOOTER //
// ./client/app/scripts/wizard.js